import React from 'react';
import Typography from './common/Typography';
import styled from 'styled-components';
import Badge from './common/Badge';

const SubTitleStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0px 20px;

  .title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
  }
`;

const SubTitleSection = ({ title, img, badge }) => {
  return (
    <SubTitleStyled className="displayFlex">
      <div className="title">
        {badge && (
          <Badge color="error" size="medium">
            필수
          </Badge>
        )}
        <Typography variant="subtitleBold" style={{ whiteSpace: 'pre-wrap' }}>
          {title}
        </Typography>
      </div>
      <img src={img} alt={title} />
    </SubTitleStyled>
  );
};

export default SubTitleSection;
